// components/CookieBanner.jsx
// Shows once, stores consent in localStorage
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('arhat_cookie_consent');
    if (!consent) setTimeout(() => setVisible(true), 1500);
  }, []);

  const accept = () => {
    localStorage.setItem('arhat_cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('arhat_cookie_consent', 'essential_only');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 24, left: '50%',
      transform: 'translateX(-50%)',
      width: 'min(520px, calc(100vw - 32px))',
      zIndex: 9999,
      background: '#0c0f18',
      border: '1px solid rgba(255,255,255,.1)',
      borderRadius: 14,
      padding: '16px 20px',
      boxShadow: '0 16px 48px rgba(0,0,0,.5)',
      fontFamily: '"DM Sans", system-ui, sans-serif',
      animation: 'slideUp .3s ease',
    }}>
      <style>{`@keyframes slideUp{from{opacity:0;transform:translateX(-50%) translateY(16px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}`}</style>

      <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
        <span style={{ fontSize: 22, flexShrink: 0 }}>🍪</span>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13.5, fontWeight: 700, color: '#dce6fa', marginBottom: 5 }}>
            We use cookies
          </div>
          <div style={{ fontSize: 12.5, color: 'rgba(220,230,250,.55)', lineHeight: 1.6 }}>
            Essential cookies keep you logged in. Optional analytics cookies help us improve the tools.
            We never sell your data.{' '}
            <Link to="/privacy" style={{ color: '#00c8f0', textDecoration: 'none' }}>Privacy Policy</Link>
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
            <button onClick={accept} style={{
              padding: '7px 18px', borderRadius: 7, border: 'none',
              background: 'linear-gradient(135deg,#00c8f0,#4d8fff)',
              color: '#07080c', fontSize: 13, fontWeight: 700,
              cursor: 'pointer', fontFamily: 'inherit',
            }}>
              Accept all
            </button>
            <button onClick={decline} style={{
              padding: '7px 16px', borderRadius: 7,
              border: '1px solid rgba(255,255,255,.12)',
              background: 'transparent', color: 'rgba(220,230,250,.6)',
              fontSize: 13, cursor: 'pointer', fontFamily: 'inherit',
            }}>
              Essential only
            </button>
          </div>
        </div>
        <button onClick={decline} style={{
          background: 'none', border: 'none', color: 'rgba(255,255,255,.3)',
          fontSize: 16, cursor: 'pointer', flexShrink: 0, padding: '2px 4px',
        }}>✕</button>
      </div>
    </div>
  );
}
